import React, { useState } from "react";
import { Container, Menu, Segment, Visibility } from "semantic-ui-react";

export const Navbar = (props) => {
  const [state, setState] = useState({ fixed: false });
  const [currentItem, setCurrentItem] = useState("DATASET");
  const handleClick = (e, { name }) => {
    setCurrentItem(name);
  };

  const hideFixedMenu = () => {
    setState({ fixed: false });
  };
  const showFixedMenu = () => {
    setState({ fixed: true });
  };

  return (
    <Visibility
      once={false}
      onBottomPassed={showFixedMenu}
      onBottomPassedReverse={hideFixedMenu}
    >
      <Segment inverted vertical>
        <Menu
          fixed="top"
          inverted
          pointing
          secondary
          style={{ backgroundColor: "black", padding: "1em" }}
        >
          <Container inverted>
            <Menu.Item
              name="DATASET"
              active={currentItem === "DATASET"}
              onClick={handleClick}
              position="left"
              href="#"
            >
              DATASET
            </Menu.Item>
            <Menu.Item
              name="PUBLICATION"
              active={currentItem === "PUBLICATION"}
              onClick={handleClick}
              position="left"
              href="#publication"
            >
              PUBLICATION
            </Menu.Item>
            <Menu.Item
              name="DOWNLOADS"
              active={currentItem === "DOWNLOADS"}
              onClick={handleClick}
              href="#downloads"
            >
              DOWNLOADS
            </Menu.Item>
            <Menu.Item
              name="TEAM"
              active={currentItem === "TEAM"}
              onClick={handleClick}
              position="right"
              href="#team"
            >
              TEAM
            </Menu.Item>
          </Container>
        </Menu>
      </Segment>
    </Visibility>
  );
};
